export default function (s) {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    s.pods.each(function () {
        const $podsContainer = $(this).find('.podcontainer');

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            $podsContainer.each(function () {
                $(this).addClass("flex-column");
            });
        }
    });
}
